import { PageSizeOption } from './types';

/** Offered by the table and by the pagination hooks unless overridden. */
export const DEFAULT_PAGE_SIZE_OPTIONS: PageSizeOption[] = [5, 10, 25, 50, 100];

/**
 * Page size before anything better is known. Auto-fit replaces it on the first
 * measurement — which happens before paint — so it is rarely seen.
 */
export const DEFAULT_INITIAL_PAGE_SIZE = 25;
